import styled from 'styled-components';

export const $MultiValueLabel = styled.div`
  overflow: hidden;
`;
